const namespaced = true

const state = {
  globalTable: {
    search: null,
    totalPage: 1,
    totalData: 0,
    currentPage: 1,
    pageSize: 10,
    pageSizes: [
      { text: '10', value: 10 },
      { text: '15', value: 15 },
      { text: '20', value: 20 },
      { text: '25', value: 25 },
      { text: '30', value: 30 },
      { text: '35', value: 35 },
      { text: '40', value: 40 },
      { text: '45', value: 45 },
      { text: '50', value: 50 }
    ]
  },
  secondaryTable: {
    search: null,
    totalPage: 1,
    totalData: 0,
    currentPage: 1,
    pageSize: 10,
    pageSizes: [
      { text: '10', value: 10 },
      { text: '15', value: 15 },
      { text: '20', value: 20 },
      { text: '25', value: 25 },
      { text: '30', value: 30 },
      { text: '35', value: 35 },
      { text: '40', value: 40 },
      { text: '45', value: 45 },
      { text: '50', value: 50 }
    ]
  }
}

const getters = {
  search: (state) => state.globalTable.search,
  totalPage: (state) => state.globalTable.totalPage,
  totalData: (state) => state.globalTable.totalData,
  currentPage: (state) => state.globalTable.currentPage,
  pageSize: (state) => state.globalTable.pageSize,
  pageSizes: (state) => state.globalTable.pageSizes,
  defaultConfig: state => ({
    search: state.globalTable.search,
    totalPage: state.globalTable.totalPage,
    currentPage: state.globalTable.currentPage,
    pageSize: state.globalTable.pageSize
  }),
  secondaryTableSearch: (state) => state.secondaryTable.search,
  secondaryTableTotalPage: (state) => state.secondaryTable.totalPage,
  secondaryTableTotalData: (state) => state.secondaryTable.totalData,
  secondaryTableCurrentPage: (state) => state.secondaryTable.currentPage,
  secondaryTablePageSize: (state) => state.secondaryTable.pageSize,
  secondaryTablePageSizes: (state) => state.secondaryTable.pageSizes,
  secondaryTableDefaultConfig: state => ({
    search: state.secondaryTable.search,
    totalPage: state.secondaryTable.totalPage,
    currentPage: state.secondaryTable.currentPage,
    pageSize: state.secondaryTable.pageSize
  })
}

const mutations = {
  SET_SEARCH: (state, payload) => {
    state.globalTable.search = payload
  },
  SET_TOTAL_PAGE: (state, payload) => {
    state.globalTable.totalPage = payload
  },
  SET_TOTAL_DATA: (state, payload) => {
    state.globalTable.totalData = payload
  },
  SET_CURRENT_PAGE: (state, payload) => {
    state.globalTable.currentPage = payload
  },
  SET_PAGE_SIZE: (state, payload) => {
    state.globalTable.pageSize = payload
  },
  SET_SEARCH_SECONDARY_TABLE: (state, payload) => {
    state.secondaryTable.search = payload
  },
  SET_TOTAL_PAGE_SECONDARY_TABLE: (state, payload) => {
    state.secondaryTable.totalPage = payload
  },
  SET_TOTAL_DATA_SECONDARY_TABLE: (state, payload) => {
    state.secondaryTable.totalData = payload
  },
  SET_CURRENT_PAGE_SECONDARY_TABLE: (state, payload) => {
    state.secondaryTable.currentPage = payload
  },
  SET_PAGE_SIZE_SECONDARY_TABLE: (state, payload) => {
    state.secondaryTable.pageSize = payload
  }
}

const actions = {
  resetConfig({ commit }) {
    commit('SET_SEARCH', null)
    commit('SET_TOTAL_PAGE', 1)
    commit('SET_TOTAL_DATA', 0)
    commit('SET_CURRENT_PAGE', 1)
    commit('SET_PAGE_SIZE', 10)
  },
  resetConfigSecondaryTable({ commit }) {
    commit('SET_SEARCH_SECONDARY_TABLE', null)
    commit('SET_TOTAL_PAGE_SECONDARY_TABLE', 1)
    commit('SET_TOTAL_DATA_SECONDARY_TABLE', 0)
    commit('SET_CURRENT_PAGE_SECONDARY_TABLE', 1)
    commit('SET_PAGE_SIZE_SECONDARY_TABLE', 10)
  }
}

export default { namespaced, state, getters, mutations, actions }
